export const WORKFLOW_ID = 'RetirementWorkflow';
export const ANALYTICS_ID = 'retirement_workflow';
